import { render, staticRenderFns } from "./product-pictures.vue?vue&type=template&id=7e20ffab&scoped=true"
import script from "./product-pictures.vue?vue&type=script&lang=ts"
export * from "./product-pictures.vue?vue&type=script&lang=ts"
import style0 from "./product-pictures.vue?vue&type=style&index=0&id=7e20ffab&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e20ffab",
  null
  
)

export default component.exports